<template>
	<div class="application--wrap centered-content">
		<v-toolbar transparent :flat="true" app class="white--text">
			<v-btn icon @click="goBack()">
				<v-icon color="white">arrow_back</v-icon>
			</v-btn>
			<v-toolbar-title>Registreren</v-toolbar-title>
			<v-btn icon></v-btn>
		</v-toolbar>

		<v-content>
			<v-container>
				<form class="text-xs-center"
					  @submit.prevent="submit">

					<validation-observer ref="validationObserver">

						<validation-provider ref="emailValidator" name="E-mail" rules="required|email|unique:email"
											 v-slot="{ errors }" slim>
							<input type="hidden" v-model="email"/>
						</validation-provider>

						<validation-provider ref="passwordValidator" vid="password" name="Wachtwoord" rules="required"
											 v-slot="{ errors }">
							<input type="hidden" v-model="password"/>
						</validation-provider>

						<validation-provider name="Aanhef" rules="required" v-slot="{ errors }" slim>
							<v-select
								v-model="namePrefix"
								:error-messages="errors[0]"
								label="Aanhef *"
								:items="['Dhr.', 'Mevr.']"
								required box dark hide-details
								class="mb-2"
							></v-select>
						</validation-provider>
						<validation-provider name="Voorletters/Voornaam" rules="required" v-slot="{ errors }" slim>
							<v-text-field
								v-model="firstName"
								:error-messages="errors[0]"
								label="Voorletters/Voornaam *"
								required box dark hide-details
								class="mb-2"
							></v-text-field>
						</validation-provider>
						<v-text-field
							v-model="lastNamePrefix"
							label="Tussenvoegsel"
							box dark hide-details
							class="mb-2"
						></v-text-field>
						<validation-provider name="Achternaam" rules="required" v-slot="{ errors }" slim>
							<v-text-field
								v-model="lastName"
								:error-messages="errors[0]"
								label="Achternaam *"
								required box dark hide-details
								class="mb-5"
							></v-text-field>
						</validation-provider>
					</validation-observer>

					<v-btn
						type="submit"
						block large depressed
						color="primary"
						class="white--text mb-2"
					>
						Registreren
					</v-btn>

				</form>

			</v-container>
		</v-content>
	</div>
</template>

<script>
  import { ValidationProvider, ValidationObserver } from 'vee-validate';
  import { mapFields } from 'vuex-map-fields';

  export default {
    components: { ValidationProvider, ValidationObserver },
    computed: {
      ...mapFields('registerUser', [
        'user.email',
        'user.password',
        'user.namePrefix',
        'user.firstName',
        'user.lastNamePrefix',
        'user.lastName',
      ])
    },
    methods: {
      goBack() {
        this.$router.push('/register');
      },
      async submit() {
        const valid = await this.$refs.validationObserver.validate();
		if (!valid) return window.scrollTo(0, 0);

		await this.$store.dispatch('registerUser/registerUser');
        this.$router.push({name: 'devices.index'});
      },
      async validateInitialState() {
        const [emailValidation, passwordValidation] = await Promise.all([
          this.$refs.emailValidator.validate(),
          this.$refs.passwordValidator.validate()
        ]);

        if(!emailValidation.valid || !passwordValidation.valid) this.goBack();
      }
    },
    mounted() {
      this.validateInitialState();
    }
  };
</script>


